<base-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="btnOkClass" [btnOkLabel]="btnOkLabel" (onOk)="ok()">
		<ng-content></ng-content>
		<p>{{message}}</p>
	</base-modal>